import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "save_doc" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Сохранение заявления", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Введите название файла", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Сохранить заявление разбитый по приложениям", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Сохранить заявление одним файлом", -1)
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalTariff = _resolveComponent("ModalTariff")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          type: "text",
          placeholder: "дизайн проект № 643 тест",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.info_save) = $event))
        }, null, 512), [
          [_vModelText, _ctx.info_save]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_5,
        _createElementVNode("button", {
          class: "save__application",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.download_separated && _ctx.download_separated(...args)))
        }, "Сохранить по приложениям")
      ]),
      _createElementVNode("div", null, [
        _hoisted_6,
        _createElementVNode("button", {
          class: "save__statement",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.download_all && _ctx.download_all(...args)))
        }, "Сохранить заявление")
      ]),
      (_ctx.load_process)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            alt: "loading...",
            class: "loading",
            src: require('../../../../assets/loading.gif'),
            style: {"width":"20px","height":"20px"}
          }, null, 8, _hoisted_7))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_component_ModalTariff, {
        is_open: _ctx.modal_end_open,
        key: _ctx.saveIter
      }, null, 8, ["is_open"]))
    ])
  ]))
}